import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Icon from '../icons/Icon';
import { LucideNavIcons } from '../icons/lucideNavIcons';
import { openContactModal } from '../redux/global/globalReducer';

import scss from './Contact.module.scss';

function Contact() {
  const { t } = useTranslation('contact');
  const dispatch = useDispatch();

  const handleOpenContactModal = () => {
    dispatch(openContactModal());
  };

  return (
    <div className={scss.wrapper}>
      <button type='button' className={scss.button} onClick={handleOpenContactModal} aria-label={t('contactUs')}>
        <div className={scss.iconWrapper}>
          <Icon icon={LucideNavIcons.Contact} size={18} className={scss.icon} disableCommonColors />
        </div>
        <span className={scss.label}>{t('contactUs')}</span>
      </button>
    </div>
  );
}

export default Contact;
